export default "<div id=\"form_div\" style=\"padding: 2rem\"></div>";